import { useTranslation } from 'react-i18next';
import { normalizeExternalUrl } from '../utils/examDates';

const NAVY  = '#0D1B2A';
const AMBER = '#F5A623';
const FONT_BODY = "'DM Sans', sans-serif";

// Optional per-posting link to a video, guide or page. Two variants for the same two surfaces
// ApprenticeshipPrerequisites serves: `dark` on the worker dashboard, `light` on the public
// union profile. Renders nothing at all when the posting has no link.
export default function ApprenticeshipResourceLink({ apprenticeship, variant = 'dark' }) {
  const { t } = useTranslation();
  const url = normalizeExternalUrl(apprenticeship?.resource_link_url);
  if (!url) return null;

  const label = (apprenticeship.resource_link_label || '').trim() || t('union.dashboard.apprModal.resourceLinkFallback');
  const light = variant === 'light';

  return (
    <a
      data-resource-link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '7px',
        fontFamily: FONT_BODY, fontSize: '0.82rem', fontWeight: 700, textDecoration: 'none',
        color: light ? NAVY : AMBER,
        border: light ? `2px solid ${NAVY}` : '1px solid rgba(245,166,35,0.45)',
        borderRadius: '6px', padding: '7px 12px', maxWidth: '100%', overflowWrap: 'anywhere',
      }}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
      {label}
    </a>
  );
}
